import React from 'react';
import { motion } from 'framer-motion';
export function TomosSection() {
  const tomos = [{
    num: 1,
    color: 'bg-blue-600',
    icon: '📘',
    title: 'Comé Rico Sin Azúcar ni Harinas',
    desc: 'La base para empezar'
  }, {
    num: 2,
    color: 'bg-green-600',
    icon: '📗',
    title: 'Desayunos y Meriendas',
    desc: 'Opciones rápidas y saludables'
  }, {
    num: 3,
    color: 'bg-orange-500',
    icon: '📙',
    title: 'Almuerzos Fáciles',
    desc: 'Comidas simples para el día a día'
  }, {
    num: 4,
    color: 'bg-red-600',
    icon: '📕',
    title: 'Cenas Livianas',
    desc: 'Para bajar de peso sin pasar hambre'
  }, {
    num: 5,
    color: 'bg-yellow-500',
    icon: '📒',
    title: 'Plan Semanal y Organización',
    desc: 'Dejá de pensar qué comer'
  }, {
    num: 6,
    color: 'bg-gray-800',
    icon: '📓',
    title: 'Sistema Completo de Alimentación',
    desc: 'Resultados sostenibles'
  }];
  return <section className="py-16 px-4 bg-gray-50" data-id="element-224">
      <div className="max-w-5xl mx-auto" data-id="element-225">
        <div className="text-center mb-12" data-id="element-226">
          <h2 className="text-3xl md:text-5xl font-black text-gray-900 mb-4 uppercase" data-id="element-227">
            📚 ESTO ES TODO LO QUE RECIBÍS HOY
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12" data-id="element-228">
          {tomos.map((tomo, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="bg-white rounded-2xl shadow-lg overflow-hidden border border-gray-200 flex flex-col h-full" data-id="element-229">
              <div className={`${tomo.color} text-white py-3 px-4 flex justify-between items-center`} data-id="element-230">
                <span className="font-black text-lg" data-id="element-231">TOMO {tomo.num}</span>
                <span className="text-2xl" data-id="element-232">{tomo.icon}</span>
              </div>
              <div className="p-6 flex-grow flex flex-col justify-between" data-id="element-233">
                <div data-id="element-234">
                  <h3 className="text-xl font-bold text-gray-900 mb-2 leading-tight" data-id="element-235">
                    {tomo.title}
                  </h3>
                  <p className="text-gray-600 font-medium mb-4" data-id="element-236">{tomo.desc}</p>
                </div>
                <div className="mt-auto pt-4 border-t border-gray-100" data-id="element-237">
                  <p className="text-sm text-gray-500 font-semibold uppercase" data-id="element-238">
                    Valor estimado:{' '}
                    <span className="line-through text-red-500" data-id="element-239">$10.000</span>
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>

        <div className="text-center bg-yellow-100 py-4 px-6 rounded-xl border-2 border-yellow-300 max-w-2xl mx-auto shadow-md" data-id="element-240">
          <p className="text-xl md:text-2xl font-black text-gray-900" data-id="element-241">
            👉 Un sistema completo listo para usar desde hoy
          </p>
        </div>
      </div>
    </section>;
}